import ReactPaginate from 'react-paginate'
import styles from './pagination.module.scss'
import clsx from 'clsx'
import {Col} from 'react-bootstrap'
interface PaginationProps {
  limit: number
  onPageChange: (selectedPage: number) => void
  onLimitChange: (limit: number) => void
  isLoading?: boolean
  total: number
  totalPages: number
  loadedData: {
    startLoad: number
    endLoad: number
  }
  paginationType?: 'index' | 'cursor'
  hasNext?: boolean
  hasPrev?: boolean
  onNext?: () => void
  onPrev?: () => void
}

const LIMIT_OPTIONS = [10, 20, 50]
const Pagination = ({
  limit,
  onPageChange,
  onLimitChange,
  isLoading,
  loadedData,
  total,
  totalPages,
  paginationType = 'index',
  hasNext,
  hasPrev,
  onNext,
  onPrev,
}: PaginationProps) => {
  return (
    <div className={clsx(styles['pagination-container'])}>
      <Col xs={12} md={6} className={styles['pagination-info']}>
        <select
          onChange={(e) => {
            onLimitChange(parseInt(e.target.value))
          }}
          value={limit}
        >
          {LIMIT_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        {paginationType === 'index'
          ? isLoading
            ? '. . . . .'
            : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${total} data`
          : null}
      </Col>
      <Col xs={12} md={6}>
        {paginationType === 'index' ? (
          <ReactPaginate
            previousLabel='<'
            nextLabel='>'
            pageCount={totalPages}
            onPageChange={({selected}) => {
              onPageChange(selected)
            }}
            containerClassName={clsx(styles['pagination-custom'])}
            previousLinkClassName={styles['pagination__link']}
            nextLinkClassName={styles['pagination__link']}
            disabledClassName={styles['pagination__link--disabled']}
            activeClassName={styles['pagination__link--active']}
          />
        ) : (
          <div className={clsx(styles['pagination-custom'])}>
            <button
              className={styles['pagination__link']}
              onClick={() => onPrev && onPrev()}
              disabled={!hasPrev || isLoading}
            >
              {'<'}
            </button>
            <button
              className={styles['pagination__link']}
              onClick={() => onNext && onNext()}
              disabled={!hasNext || isLoading}
            >
              {'>'}
            </button>
          </div>
        )}
      </Col>
    </div>
  )
}

export default Pagination
